<template>
  <div>
    <vetster-slot-wrapper
      :slots="controlsOrder"
      class="flex space-x-4 w-full px-standard"
      :class="{
        'items-center mb-4': isCentered,
        'items-end': !isCentered,
      }"
    >
      <template #label>
        <h4
          :class="labelClasses"
          class="w-full"
        >
          {{ label || $t('quote.choose-a-date') }}
        </h4>
      </template>
      <template #slide-left>
        <button
          type="button"
          aria-hidden="true"
          :aria-label="$t('search.slide-left')"
          class="text-2xl hover:opacity-70"
          :class="{ 'cursor-not-allowed opacity-50 pointer-events-none': isOnInitialPosition }"
          @click="slideLeft"
        >
          <fa :icon="['fal', 'circle-arrow-left']" />
        </button>
      </template>
      <template #slide-right>
        <button
          type="button"
          aria-hidden="true"
          :aria-label="$t('search.slide-right')"
          :class="{ 'cursor-not-allowed opacity-50 pointer-events-none': isOnFinalPosition }"
          class="text-2xl hover:opacity-70"
          @click="slideRight"
        >
          <fa :icon="['fal', 'circle-arrow-right']" />
        </button>
      </template>
    </vetster-slot-wrapper>
    <vetster-date-button
      ref="timeslots"
      :date="inputs.date_from"
      :timezone="inputs.timezone"
      :center-full-date="isCentered"
      :show-next-available-button="showNextAvailableButton"
      class="mt-4 lg:mt-2"
      @update="handleDay"
      @updateControls="updateControls"
    />
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCircleArrowLeft,
  faCircleArrowRight,
} from '@fortawesome/pro-light-svg-icons';
import { mapState } from 'vuex';

import VetsterDateButton from '@/brand-components/GuidedSearch/VetsterDateButton';
import VetsterSlotWrapper from '@/brand-components/VetsterSlotWrapper';

library.add({
  faCircleArrowLeft,
  faCircleArrowRight,
});

export default {
  name: 'VetsterSearchDayPicker',

  components: {
    VetsterDateButton,
    VetsterSlotWrapper,
  },

  props: {
    isCentered: {
      type: Boolean,
      default: false,
    },
    isFilter: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    labelClasses: {
      type: String,
      default: 'text-neutral-900 font-medium lg:font-bold',
    },
    showNextAvailableButton: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isOnInitialPosition: true,
      isOnFinalPosition: false,
    };
  },

  computed: {
    ...mapState('search', ['inputs']),

    controlsOrder() {
      if (this.isCentered) {
        return [
          'slide-left',
          'label',
          'slide-right',
        ];
      }

      return [
        'label',
        'slide-left',
        'slide-right',
      ];
    },
  },

  methods: {
    handleDay(date) {
      if (!this.showNextAvailableButton) {
        this.$store.dispatch('quote/setDateAndFetchAvailability', date);
      }

      this.$store.commit('search/setTempInputs', {
        date_from: date,
      });
    },
    slideRight() {
      this.$refs.timeslots.slideRight();
    },
    slideLeft() {
      this.$refs.timeslots.slideLeft();
    },
    updateControls({ isOnInitialPosition, isOnFinalPosition }) {
      this.isOnInitialPosition = isOnInitialPosition;
      this.isOnFinalPosition = isOnFinalPosition;
    },
  },
};
</script>
